import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Donor } from "../../../../models";
import { Links } from "../../../main/blocks/Links/Links";
import { FacebookTaxWidget } from "../FacebookTaxWidget/FacebookTaxWidget";
import style from "./FacebookTab.module.scss";
import { PortableText } from "@portabletext/react";
export const FacebookTab: React.FC<{
  donor: Donor;
  description: any[];
  links: any[];
}> = t0 => {
  const $ = _c(13);
  const {
    donor,
    description,
    links
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h5>Knytt din donasjon til din profil</h5>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== donor.email) {
    t2 = <section><FacebookTaxWidget email={donor.email} /></section>;
    $[1] = donor.email;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <PortableText value={description} />;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== links) {
    t4 = <Links links={links} />;
    $[5] = links;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <section>{t3}{t4}</section>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className={style.container}>{t1}<div className={style.gridContainer}>{t2}{t5}</div></div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};